/**
 * The legal-document routes' path contract (ENROLL lane). Mirrors
 * goodbyeRoute.ts's own precedent exactly: a tiny pure module so App.tsx's
 * routing decision is unit-testable without mounting <App> (this repo has no
 * jsdom/React-Testing-Library setup).
 *
 * /terms and /privacy must be reachable regardless of auth state — a
 * signed-out stranger reads them from SignIn's footer before ever clicking
 * "Continue with Google," and a signed-in user reads them from Settings or
 * the enrollment consent step. App.tsx therefore checks
 * shouldRenderLegalDoc() BEFORE the `!auth.user` gate, the same precedence
 * shouldRenderGoodbye() already has over that gate.
 */
export const TERMS_PATH = '/terms';
export const PRIVACY_PATH = '/privacy';

export type LegalDocRoute = 'terms' | 'privacy' | null;

export function resolveLegalDocRoute(pathname: string): LegalDocRoute {
  if (pathname === TERMS_PATH || pathname === `${TERMS_PATH}/`) return 'terms';
  if (pathname === PRIVACY_PATH || pathname === `${PRIVACY_PATH}/`) return 'privacy';
  return null;
}
